module.exports = __webpack_public_path__ + "img/Dantam Hair 46.fb707f84.jpg";